<template>
  <section class="third">
    <div class="container">
      <div class="wrap">
        <h3>Certifications</h3>
      </div>
      <div class="certifications">
        <div
          class="certification"
          v-for="(certification, index) in certifications"
          :key="index"
        >
          <div :data-aos="certification.direction" class="cer-card">
            <div class="front">
              <h4>{{ certification.name }}</h4>
              <div class="row">
                <p>{{ certification.description }}</p>
                <a
                  v-if="certification.link"
                  :href="certification.link"
                  target="_blank"
                  >credential</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "CertiComponent",
  data() {
    return {
      certifications: [
        {
          name: "Ruby Association Certified Ruby Programmer　Silver Version 3",
          description: "Issued Sep 2023",
          direction: "fade-down",
          link: "https://www.credential.net/de473b7f-6c0d-4491-8fc8-b07457661451?key=95ed05b2ba6509327e8dbefa30a90bddff29ce1fd79c3b99c2e8cbabee40870d#gs.4zypod",
        },
        {
          name: "Photoshop®クリエイター能力認定試験　Standard(2020)",
          description: "Issued Sep 2023",
          direction: "fade-down",
          link: "https://www.openbadge-global.com/ns/portal/openbadge/public/assertions/detail/aHgxZklpMW5iVUZoZ0dtSkJUSzhuZz09",
        },
        {
          name: "VBAエキスパート　Excel VBA Basic",
          description: "Issued Sep 2023",
          direction: "fade-down",
          link: "https://www.openbadge-global.com/ns/portal/openbadge/public/assertions/detail/aUNKUHdmRmFJQjIzeE9TeXpUc0hZZz09",
        },
        {
          name: "C言語プログラミング能力認定試験　3級",
          description: "Issued Sep 2023",
          direction: "fade-down",
          link: "https://www.openbadge-global.com/api/v1.0/openBadge/v2/Wallet/Public/GetAssertionShare/SVk5cDNmVzdoTklFNkVGOEJwbnJvdz09",
        },
        {
          name: "Oracle Certified Java Programmer　Gold SE 11",
          description: "Issued Aug 2023",
          direction: "fade-down",
          link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=C7E3D1B2FDCDFFCE3530C87BC3D686B3224F07CD42908E6E8D6040B9606D20A8",
        },
        {
          name: "Illustrator®クリエイター能力認定試験　Standard(CS6)",
          description: "Issued Aug 2023",
          direction: "fade-down",
          link: "https://www.openbadge-global.com/ns/portal/openbadge/public/assertions/detail/NExHZVFyYUVkUjNOZkhSNjdVU3k0UT09",
        },
        {
          name: "App Development with Swift",
          description: "Issued Jul 2023",
          direction: "fade-down",
          link: "https://www.credly.com/badges/6f37716b-9169-4293-b588-257b1b28a3be",
        },
        {
          name: "AWS Certified Cloud Practitioner",
          description: "Issued Jul 2023",
          direction: "fade-down",
          link: "https://www.credly.com/badges/2dbaf1b4-739d-4599-b39e-51bb6f2fb41d",
        },
        {
          name: "PHP7技術者認定試験　初級",
          description: "Issued Jul 2023",
          direction: "fade-down",
        },
        {
          name: "Java™プログラミング能力認定試験　２級",
          description: "Issued Jul 2023",
          direction: "fade-down",
          link: "https://www.openbadge-global.com/ns/portal/openbadge/public/assertions/detail/WUROdkt5ZHpaSTJuUXJGazBCb1hoZz09",
        },
        {
          name: "Oracle Certified Java Programmer Silver SE 11",
          description: "Issued Jun 2023",
          direction: "fade-down",
          link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=F75C6392CF44B458B27CDE2A323B6A19670FAC32653494A5D8DCECFF8C7D7209",
        },
        {
          name: "3rd grade Certified Skilled Worker of Web Design",
          description: "Issued Jun 2023",
          direction: "fade-down",
        },
        {
          name: "Oracle Certified Java Programmer Bronze SE 11",
          description: "Issued May 2023",
          direction: "fade-down",
          link: "https://catalog-education.oracle.com/pls/certview/sharebadge?id=31F091938654841061F657802B32CF63276524A60F2D74DE60A7F1A15204D6D2",
        },
        {
          name: "Information Technology Passport Examination",
          description: "Issued May 2023",
          direction: "fade-down",
        },
        {
          name: "HTML5 Professional Certification　Level 1",
          description: "Issued Apr 2023",
          direction: "fade-down",
          link: "https://ma.educo-j.or.jp/h/EID900037973/88cajlgsw9",
        },
        {
          name: "Webクリエイター能力認定試験　Standard",
          description: "Issued Apr 2023",
          direction: "fade-down",
          link: "https://www.openbadge-global.com/ns/portal/openbadge/public/assertions/detail/aklZSWlmdXVxcFVnbFMxbGcxVUJHZz09",
        },
        {
          name: "Test of English as a Foreign Language (TOELF)　81",
          description: "Issued Feb 2020",
          direction: "fade-down",
        },
        {
          name: "Japanese-Language Proficiency Test (JLPT)　N1",
          description: "Issued Aug 2019",
          direction: "fade-down",
        },
        {
          name: "Test of English for International Communication (TOEIC)　865",
          description: "Issued Mar 2017",
          direction: "fade-down",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1280px;
  margin: 5rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wrap {
    background-image: linear-gradient(
      to top,
      #fff 50%,
      #2f9e44 50%,
      #2f9e44 75%,
      #fff 75%
    );

    h3 {
      border-bottom: 3px solid #1f0d14;
      padding: 0 1.5rem;
      margin: 3rem 9rem;
      font-family: "Acme", Arial, sans-serif;
      font-size: 3rem;
      color: #1f0d14;
      filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.4));
    }
  }

  .certifications {
    margin-top: 3rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .cer-card {
      margin-bottom: 2.5rem;
      width: 50rem;
      height: 7rem;
      font-family: "Lato", Arial, sans-serif;

      .front {
        width: 100%;
        height: 7rem;
        box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.15);
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: center;
        border-radius: 10px;
        background-image: linear-gradient(to top right, #fff 70%, #2f9e44 90%);
      }

      h4,
      p {
        display: block;
        padding: 0 2.5rem;
        color: #1f0d14;
      }

      h4 {
        font-size: 1.1rem;
        line-height: 2rem;
      }

      .row {
        display: flex;
      }

      p {
        font-size: 0.9rem;
        line-height: 1.5rem;
      }

      a {
        text-decoration: none;
        font-size: 0.9rem;
        border: 1px solid #2f9e44;
        padding: 0.1rem 0.3rem;
        color: inherit;

        &:hover {
          transition: all 0.3s ease-in;
          color: #2f9e44;
        }

        display: inline-block;
      }
    }
  }
}

@media screen and (max-width: 900px) {
  .container {
    .certifications {
      .cer-card {
        width: 40rem;
      }
    }
  }
}

@media screen and (max-width: 700px) {
  .container {
    .wrap {
      h3 {
        margin: 3rem 4rem;
      }
    }

    .certifications {
      .cer-card {
        width: 30rem;
      }
    }
  }
}

@media screen and (max-width: 600px) {
  .container {
    .wrap {
      h3 {
        margin: 3rem 3rem;
      }
    }

    .certifications {
      .cer-card {
        width: 25rem;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .container {
    .wrap {
      h3 {
        margin: 3rem 2rem;
      }
    }

    .certifications {
      .cer-card {
        width: 20rem;

        h4,
        p {
          padding-left: 1rem;
          padding-right: 1rem;
        }
      }
    }
  }
}
</style>
